module.exports = __webpack_public_path__ + "img/Screen 1.29c937b0.png";